import { Constraint } from '../../shopfloor/workcenters/capability/constraints/constraint'

export enum ScheduleMismatchReason {
  WORK_HOURS = 'WORK_HOURS',
  STRATEGY_AVOID = 'STRATEGY_AVOID',
  STRATEGY_NEVER = 'STRATEGY_NEVER',
  CONSTRAINT = 'CONSTRAINT',
}

export interface WorkItemScheduleMatchResult {
  readonly mismatchReasons: ScheduleMismatchReason[]
  // only if reason === CONSTRAINT
  readonly prodRouteMatchResult: ProductionRouteMatchResult
}

export interface ProductionRouteMatchResult {
  readonly actionsMatch: boolean
  readonly constraintMatchResult: ConstraintMatchResult
}

export interface ConstraintMatchResult {
  readonly matches: boolean
  readonly constraint: Constraint
  readonly inputValue: string
}

export class ScheduleStep {
  public workCenterId: string
  public workCenterNumber: string
  public workCenterName: string

  public capabilityName: string
  public actions: string[] = []
  public capacityUsage: string // Duration
  public makeSpan: string // Duration

  public matchResult: WorkItemScheduleMatchResult
}

export class WorkItemSchedule {
  public path: string
  public segments: ScheduleStep[] = []
  public makeSpan: string // Duration
  public workCenterNumberSequence: string
}
